module.exports = __webpack_public_path__ + "static/media/eva_st.e2bd8900.mp4";